__webpack_require__.p = "/winners-and-losers-of-international-trade/";